// @flow
import $ from 'jquery';

export function fixHeaderTab(
  breakPoint: number,
  tabField: string,
  tabUnderField: string,
) {
  const winScroll = $(window).scrollTop();
  const headerHeight = 60;
  const scrollPosition = winScroll + headerHeight;
  if (
    !$(`.${tabField}`).hasClass('tab-field-fixed') &&
    breakPoint < scrollPosition
  ) {
    $(`.${tabUnderField}`).addClass('show-body-tab-fixed');
    $(`.${tabField}`).addClass('tab-field-fixed');
  } else if (
    $(`.${tabField}`).hasClass('tab-field-fixed') &&
    breakPoint > scrollPosition
  ) {
    $(`.${tabUnderField}`).removeClass('show-body-tab-fixed');
    $(`.${tabField}`).removeClass('tab-field-fixed');
  }
}
